import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { AnexoLdoComponent } from './anexo-ldo.component';
import { AnexoLdoRoutingModule } from './anexo-ldo-routing.module';
import { SharedModule } from 'eddydata-lib';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  declarations: [AnexoLdoComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AnexoLdoRoutingModule,
    ListboxModule,
    FieldsetModule,
    RadioButtonModule,
  ]
})
export class AnexoLdoModule { }